/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

<template>
  <div v-bind:class="[amplifyUI.formSection, 'main-section',  errored ? 'errored' : 'normal']" v-bind:data-test="auth.confirmSignIn.section">
    <div v-bind:class="[amplifyUI.sectionHeader, 'header-section']" v-bind:data-test="auth.confirmSignIn.headerSection">{{options.header}}</div>
    <div v-bind:class="amplifyUI.sectionBody" v-bind:data-test="auth.confirmSignIn.bodySection">
      <div v-bind:class="amplifyUI.formField">
        <div v-bind:class="[amplifyUI.inputLabel, 'input-label']">&nbsp;</div>
        <!--<a id="otplink"  :href="otpauthUrl" @click="handleClick" :class="{ disabled: isClicked || !isMobile }"></a>-->
        <v-otp-input :ref="'otpInput'" :input-classes="'otp-input'" :separator="'&nbsp;'" :num-inputs="6" :should-auto-focus="true" :is-input-num="true" @on-change="handleOnChange"  @on-complete="handleOnComplete"  v-bind:class="amplifyUI.input" :placeholder="'enter the code from the authenticator app'" v-bind:data-test="auth.confirmSignIn.codeInput" />
      </div>
    </div>
    <div v-bind:class="[amplifyUI.sectionFooter, 'footer-section']">
      <span v-bind:class="amplifyUI.sectionFooterPrimaryContent">
        <button :disabled="!(code && code.length >= 6)" v-bind:class="amplifyUI.button" v-on:click="submit" v-bind:data-test="auth.confirmSignIn.confirmButton">
          <geno-spinner :loading="flow" :text="$Amplify.I18n.get('Confirm')" :size="32"></geno-spinner>
        </button>
      </span>
      <span v-bind:class="[amplifyUI.sectionFooterSecondaryContent, 'secondary-content']">
        <a v-bind:class="amplifyUI.a" v-on:click="signIn" v-bind:data-test="auth.confirmSignIn.backToSignInLink">{{$Amplify.I18n.get('Back to Sign In')}}</a>      
      </span>
    </div>
    <div class="error" v-if="false">
      {{ error }}
    </div>
  </div>
</template>


<script>
        //<input v-bind:class="amplifyUI.input" v-model="code" :placeholder="'enter the code from the authenticator app'" v-bind:data-test="auth.confirmSignIn.codeInput" />
import AmplifyEventBus from '../../events/AmplifyEventBus';
import * as AmplifyUI from '@aws-amplify/ui';
import { auth } from '../../assets/data-test-attributes';
import otpInput from "@/components/vue-otp-input";

export default {
  name: 'ConfirmSignIn',
  props: ['confirmSignInConfig'],
  data () {
    return {
      verifyAttr: '',
      flow: false,
      isClicked: false,
      otpauthUrl: undefined,
      code: '',
      error: '',
      errored: false,
      logger: {},
      amplifyUI: AmplifyUI,
      auth
    }
  },
  computed: {
    options() {
      const defaults = {
        header: this.$Amplify.I18n.get('Confirm Sign In'),
        user: {},
      }
      return Object.assign(defaults, this.confirmSignInConfig || {})
    }
  },
  mounted() {
    this.otpauthUrl = `otpauth://totp/Genoplot:${this.options.user}`;
    this.errored =  false;
    this.isClicked = false;
    this.logger = new this.$Amplify.Logger(this.$options.name);
      AmplifyEventBus.$emit('loginErrors', { source: 'confirmSignIn', error: this.error})
    if (Object.keys(this.options.user).length === 0) {
      this.setError('Valid user not received.');
    };
  },
  methods: {
        isMobile: function() {
            let ios = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
            let mobile = navigator.userAgentData && navigator.userAgentData.mobile ? true : false
            return (ios || mobile) ? true : false
        },
    submit: function() {
      this.flow = true;
      this.$Amplify.Auth.confirmSignIn(this.options.user, this.code, this.options.user.challengeName)
        .then(() => {
          this.errored =  false;
          this.logger.info('confirmSignIn successs');
          sessionStorage.setItem('mfalogin', true)
          console.log('set session var')
          AmplifyEventBus.$emit('authState', 'signedIn');
          this.flow = false
        })
        .catch(e => {
        this.flow = false;
      this.handleClearInput()
        this.setError(e);
        })
    },
    handleClick(event) {
      if (this.isClicked || !this.isMobile) {
        event.preventDefault(); // Prevent the link from being invoked again
      } else {
        this.isClicked = true;  // Mark the link as clicked
      }
    },
    handleOnComplete(value) {
			this.code = value
      this.submit()
    },
    handleOnChange(value) {
			this.code = value
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput();
			this.code = null;
    },
    signIn: function() {
      AmplifyEventBus.$emit('authState', 'signIn');
    },
    setError: function(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
    this.errored =  true;
      let loginErrors = e.message || e
      try {
      loginErrors = loginErrors.replace(/^.*failed with error/,'')
      }
      catch(err) {
      }
      AmplifyEventBus.$emit('loginErrors', { source: 'confirmSignIn', error: loginErrors})
      this.logger.error(this.error);
    }
  },
	components: {
	'v-otp-input': otpInput
	}
}
</script>
<style>
div[is_input_num="true"] input { 
border: 2px solid gray;
}
</style>
